import { StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

export const desktopDropdownStyles = StyleSheet.create({
  menuItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconWrap: {
    width: 24,
    alignItems: 'center',
    marginRight: 12,
  },
  menuText: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_SECONDARY,
  },
});
